import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/regions',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/list/RegionsListPage').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/regions/create',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/create/RegionCreatePage').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/regions/:id',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/edit/RegionEditPage').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];
export default routes;
